import classes from './infoBar.module.css'
import classesK from '../../kalkulatori.module.css'
import Axios from 'axios'
import { useState, useEffect } from 'react'
import { betkoPopupWithAction } from './../../../utils/BetkoPopupModal'
import BetKalkulatoriLista from '../../../components/BetKalkulatoriLista'
import useIsMobile from '../../../hooks/useIsMobile'
import ForumContentPopup from '../../../components/ForumContentPopup'
import useCommentPopup from '../../../hooks/useCommentPopup'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const InfoBar = ({ calculatorType, onRefresh }) => {
  const [tutorialLink, setTutorialLink] = useState('')
  const isMobile = useIsMobile(1024)
  const { fetchAndShowPopup, loading } = useCommentPopup()

  useEffect(() => {
    const fetchLink = async () => {
      try {
        const tutorial = await Axios.get(
          `${SERVER_URL}/tutorial-calcname?name=${encodeURIComponent(
            calculatorType
          )}`
        )

        if (tutorial && tutorial.data && tutorial.data._id) {
          setTutorialLink(tutorial.data._id)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchLink()
  }, [calculatorType])

  const handlePopupOpen = (type) => {
    if (type === 'podaci') {
      betkoPopupWithAction(
        'Podaci za unos',
        '',
        'Poseti sajt bilo koje kladionice ili bilo koji drugi sajt koji obrađuje kvote i rezultate utakmica. Za detaljnija objašnjenja klikni na "Opis kalkulatora".'
      )
    } else if (type === 'instrukcije') {
      betkoPopupWithAction(
        'Instrukcije unosa',
        '',
        'Za unos podataka koristi bela polja. Ukoliko polja odvaja prikazana tačka, unesi broj i u levo i u desno polje od tačke (npr. 2 = levo . desno = 00). Ukoliko nema prikazane tačke, unesi decimalni broj uz upis tačke (npr. 2.00). Polja obeležena crvenom zvezdicom * su obavezna polja za unos u celini unosa broja ili decimalnog broja.'
      )
    }
  }

  const handleOpiskalkulatoraClick = () => {
    betkoPopupWithAction(
      null,
      '',
      () => {
        return <ForumContentPopup apiPostPath={'tutorial'} id={tutorialLink} />
      },
      {
        hasBorder: true,
        isContentCentered: false,
      }
    )
  }

  return (
    <div style={{ marginTop: '16px' }}>
      <div className={classes.container}>
        <div
          className={`${classesK.calcButtonContainer} ${classes.infoContainer}`}
        >
          <button onClick={() => handlePopupOpen('podaci')}>
            Podaci za unos
          </button>
          <button onClick={() => handlePopupOpen('instrukcije')}>
            Instrukcije unosa
          </button>
          <button onClick={onRefresh}>Osveži kalkulator</button>

          <button onClick={() => handleOpiskalkulatoraClick()}>
            Opis kalkulatora
          </button>
        </div>

        <button
          className={classes.tutorialButton}
          onClick={() => fetchAndShowPopup(calculatorType)}
          disabled={loading}
        >
          <img src='/icons/play-btn.svg' alt='play button' /> Tutorijal
        </button>
      </div>
      <div> {isMobile && <BetKalkulatoriLista />}</div>
    </div>
  )
}

export default InfoBar
